
import React from 'react'

import './calendly.scss'

class Calendly extends React.Component {
  ref = React.createRef()

  constructor(props) {
    super(props)
    if (typeof window !== 'undefined') {
      const { hash } = window.location
      this.calendlyPath = hash.split(':')[1] 
    }
  }

  componentDidMount() {
    const head = document.querySelector('head');
    this.script = document.createElement('script');
    this.script.setAttribute('src',  'https://assets.calendly.com/assets/external/widget.js');
    head.appendChild(this.script);
  }

  componentWillUnmount() {
    this.script.parentNode.removeChild(this.script)
  }

  render() {
    return (
      <div styleName='calendly' ref={this.ref}>
        <div 
          styleName="calendly-inline-widget" 
          className="calendly-inline-widget" 
          data-url={`https://calendly.com/${this.calendlyPath || ''}`} 
        />
      </div>
    )
  }
}

export default Calendly